export default "__VITE_ASSET__5dc41517__"